import React, { useReducer } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  Link
} from "react-router-dom";
import AuditProgressView from './page/AuditProgress'
import StartAuditView from './page/StartAudit'
import AuthView from './page/AuthView'
import { CookiesProvider, withCookies, useCookies } from 'react-cookie';
import { auditInfoContext, auditInfoReducer } from "./hooks/startAuditHook";
import "./App.css"

const auth = true

function PrivateRoute({ children, ...rest }) {

  const [cookies, setCookie] = useCookies(['name']);

  return (
    <Route
      {...rest}
      render={({ location }) =>
      cookies['JWTToken'] ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/auth",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}

function PublicRoute({ children, ...rest }) {

  const [cookies, setCookie] = useCookies(['name']);

  return (
    <Route
      {...rest}
      render={({ location }) =>
      cookies['JWTToken'] ? <Redirect
                  to={{
                    pathname: "/",
                    state: { from: location }
                  }}
                /> : (
        children
        )
      }
    />
  );
}


const App = () => {

  const [auditInfo, dispatchAuditInfo ] = useReducer(auditInfoReducer, {});
  console.log(66, auditInfo)
  return (
    <Router>
      <div>
        <Switch>
          <PublicRoute exact path="/auth">
            <AuthView />
          </PublicRoute>
          <PrivateRoute exact path="/">
            <AuditProgressView />
          </PrivateRoute>
          <PrivateRoute exact path="/audit-progress">
            <AuditProgressView />
          </PrivateRoute>
          <PrivateRoute exact path="/new-audit">
            <auditInfoContext.Provider value={{auditInfo, dispatchAuditInfo}}>
              <StartAuditView />
            </auditInfoContext.Provider>
          </PrivateRoute>
        </Switch>
      </div>
    </Router>
  );
}

const AppWithWrapper = () => {
  return  <CookiesProvider>
            <App />
          </CookiesProvider>
}

export default AppWithWrapper